export const CalculateRebate = (spread, commission, rebatePercentage) => {
  if (commission >= 0 && spread >= 0) {
    return ((spread + commission) * (rebatePercentage / 100)).toFixed(2);
  } else {
    return 0;
  }
};
